import { VFC } from 'react';
import Badge from '@adsk/alloy-react-badge';
import Theme from '@adsk/alloy-react-theme';
import { getStatusColor, getStatusLabel } from '../helpers/statusHelpers';
import { RfiStatus } from '../sdk';
import { StyledBadge } from './Styled';

export type StatusCellProps = {
  status: RfiStatus;
  prevStatus?: RfiStatus;
  stacked?: boolean;
  variant?: React.ComponentProps<typeof Badge>['variant'];
  style?: React.ComponentProps<typeof Badge>['style'];
};

export const StatusCell: VFC<StatusCellProps> = (props) => {
  const { status, prevStatus, stacked = true, variant = Badge.VARIANTS.LINE, style } = props;
  const statusColor = getStatusColor(status);
  const { statusLabel, subStatusLabel } = getStatusLabel(status, false, prevStatus);

  const textColor = status === RfiStatus.Closed ? Theme.colors.charcoal900 : Theme.colors.white;

  return (
    <StyledBadge
      subStatus={subStatusLabel}
      variant={variant}
      stacked={stacked}
      size={Badge.SIZES.SMALL}
      color={statusColor}
      textColor={textColor}
      style={style}
    >
      {statusLabel}
    </StyledBadge>
  );
};
